import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=bbe6a44a&"
import script from "./SwiperSlide.vue?vue&type=script&lang=ts&"
export * from "./SwiperSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports